<template>
  <div id="scroll_index" class="index" ref="Index">
    <header>
      <h3>田野商城</h3>
      <van-search
        placeholder="请输入商品名称"
        v-model="value"
        shape="round"
        @search="search"
        @focus="gosearch"
      />
    </header>
    <div class="below" id="below" ref="below"></div>
      <div ref="wrapper">
    <van-pull-refresh style="min-height: 76vh;" v-model="isLoading" @refresh="onRefresh">
        <div class="content">
          <!-- 轮播图 -->
          <van-swipe :autoplay="1000"  indicator-color="rgba(116, 180, 43, 0.45)" :height="160" id="swipe">
            <!-- <van-swipe-item v-for="(image, index) in images" :key="index">
        <img v-lazy="images" />
            </van-swipe-item>-->
            <van-swipe-item
              @click="goClassify(item)"
              v-for='item in swipeList'
              :key='item.operatingPositionId'
             >
              <img
                :src="item.showImageUrl"
                alt
                style="width:90% ;height:160px ;margin:0 auto;border-radius: 12px;"
              />
            </van-swipe-item>
          </van-swipe>
          <!-- 商品导航 -->
          <div class="ty-index-loder" v-if="classifyList.length">
            <div class="ty-index-h">
              <van-icon name="flower-o" />
              <span class="ty-index-h-span">新鲜食材</span>
              <van-icon name="logistics" />
              <span class="ty-index-h-span">冷链配送</span>
            </div>
            <van-grid :border="false" :column-num="5">
              <van-grid-item
                v-for="item in classifyList.slice(0,14)"
                :key="item.operatingPositionId"
                :text="item.imageName"
                @click="goClassify(item)"
              >
                <van-image fit='cover' :src="item.showImageUrl" />
                <p class="index-text goods_over" style="text-align: center">{{item.imageName}}</p>
              </van-grid-item>
              <van-grid-item text="更多" @click="more" v-if="classifyList.length>15">
                <van-image :src="imgURL.baseUrl  + imgURL.indexPageLists[13]" />
                <!-- <van-image src="item.picUrl" /> -->
                <p class="index-text" style="text-align: center">更多</p>
              </van-grid-item>
            </van-grid>
            <div class="ty_index_loder_footer"></div>
          </div>
          <div class="ty-index-loder" v-if="fixedUrl.showImageUrl" >
            <img style="width:100%;border-radius: 10px;" :src="fixedUrl.showImageUrl" alt="">
          </div>
          <!-- 展示区 -->
          <div class="ty-index-show" v-if="false">
            <img src="../assets/img/banner@2x.png" alt style="width:100%" />
          </div>
          <div class="ty-index-show ty-index-show-l" v-if="false">
            <div>
              <span class="ty-index-show-l-span">领卷中心</span>
              <van-row type="flex" justify="end" style="float: right;">
                <van-row></van-row>
                <van-col>
                  <van-button round type="info" size="mini" color="#E4F0D5">
                    更多
                    <van-icon name="arrow" />
                  </van-button>
                </van-col>
              </van-row>
              <!-- 优惠卷 -->
              <div class="coupons">
                <Couponsl></Couponsl>
                <Couponsl></Couponsl>
                <Couponsl></Couponsl>
              </div>
            </div>
          </div>

          <!-- 促销 -->
          <div class="promotion" v-if="false">
            <div>
              <span class="ty-index-show-l-span promotion-span">促销·推荐</span>
              <van-row type="flex" justify="end" style="float: right;">
                <van-row></van-row>
                <van-col>
                  <van-button round type="info" size="mini" color="#5D67EF" class="promotion-btn">
                    更多
                    <van-icon name="arrow" class="ic" style="color:#fff" />
                  </van-button>
                </van-col>
              </van-row>
            </div>
          </div>
          <div class="promotion-production" v-if="false">
            <div class="promotion-production-s">
              <img
                class="promotion-production-s-img"
                src="../assets/u=3209370120,2008812818&fm=26&gp=0.jpg"
                alt
              />
              <div class="promotion-production-s-p">招牌-a级无极净青菜（加工商品撒啊撒）</div>
              <span class="promotion-production-s-span-l">￥133.05</span>
              <span class="promotion-production-s-span-r">/斤</span>
            </div>
            <div class="promotion-production-s">
              <img
                class="promotion-production-s-img"
                src="../assets/u=3209370120,2008812818&fm=26&gp=0.jpg"
                alt
              />
              <div class="promotion-production-s-p">招牌-a级无极净青菜（加工商品撒啊撒）</div>
              <span class="promotion-production-s-span-l">￥133.05</span>
              <span class="promotion-production-s-span-r">/斤</span>
            </div>
            <div class="promotion-production-s">
              <img
                class="promotion-production-s-img"
                src="../assets/u=3209370120,2008812818&fm=26&gp=0.jpg"
                alt
              />
              <div class="promotion-production-s-p">招牌-a级无极净青菜（加工商品撒啊撒）</div>
              <span class="promotion-production-s-span-l">￥133.05</span>
              <span class="promotion-production-s-span-r">/斤</span>
            </div>
            <div class="promotion-production-s">
              <img
                class="promotion-production-s-img"
                src="../assets/u=3209370120,2008812818&fm=26&gp=0.jpg"
                alt
              />
              <div class="promotion-production-s-p">招牌-a级无极净青菜（加工商品撒啊撒）</div>
              <span class="promotion-production-s-span-l">￥133.05</span>
              <span class="promotion-production-s-span-r">/斤</span>
            </div>
            <div class="promotion-production-s">
              <img
                class="promotion-production-s-img"
                src="../assets/u=3209370120,2008812818&fm=26&gp=0.jpg"
                alt
              />
              <div class="promotion-production-s-p">招牌-a级无极净青菜（加工商品撒啊撒）</div>
              <span class="promotion-production-s-span-l">￥133.05</span>
              <span class="promotion-production-s-span-r">/斤</span>
            </div>
            <div class="promotion-production-s">
              <img
                class="promotion-production-s-img"
                src="../assets/u=3209370120,2008812818&fm=26&gp=0.jpg"
                alt
              />
              <div class="promotion-production-s-p">招牌-a级无极净青菜（加工商品撒啊撒）</div>
              <span class="promotion-production-s-span-l">￥133.05</span>
              <span class="promotion-production-s-span-r">/斤</span>
            </div>
            <div class="promotion-production-s">
              <img
                class="promotion-production-s-img"
                src="../assets/u=3209370120,2008812818&fm=26&gp=0.jpg"
                alt
              />
              <div class="promotion-production-s-p">招牌-a级无极净青菜（加工商品撒啊撒）</div>
              <span class="promotion-production-s-span-l">￥133.05</span>
              <span class="promotion-production-s-span-r">/斤</span>
            </div>
          </div>
        </div>
    </van-pull-refresh>
      </div>
    <!-- 导航 -->
    <tabbar :activeNew='active' />
  </div>
</template>

<script>
import Couponsl from "./common/Coupons";
import tabbar from "./common/tabbar";
export default {
  components: {
    Couponsl,
    tabbar
  },
  created() {
    const mm = require("./common/imgUrl");
    this.imgURL = mm.imgURL;
    // 获取客户ID
    this.customerId = localStorage.getItem("customerId");
    //获取商品列表
    this.getclassifyList();
    this.getFixedList();
    this.getSwipe();
  },

  // 添加滚动事件
  mounted: function() {
    window.addEventListener("scroll", this.handleScroll, true);
  },
  data() {
    return {
      value: "",
      images: [
        // "https://img.yzcdn.cn/vant/apple-1.jpg",
        // "https://img.yzcdn.cn/vant/apple-2.jpg"
      ],
      imgURL: {},
      active: 0,
      classifyList: [],
      fixedUrl: {},
      swipeList: [],
      isLoading: false
    };
  },
  beforeRouteEnter(to, from, next) {
    const token = localStorage.getItem("token");
    localStorage.setItem("companyId", to.query.companyId);
    if (token) {
      next();
    } else {
      next(vm => {
        vm.$router.push({
          path: "/accountLogin",
          query: { companyId: to.query.companyId }
        });
      });
    }
  },
  methods: {
    // 搜索
    search() {
      localStorage.setItem("searchValue", this.value);
      // localStorage.setItem("balck", "/index");
      this.$router.push("/search");
    },
    //搜索
    gosearch() {
      localStorage.removeItem("searchValue");
      this.$router.push("/search");
    },
    // 去蔬菜类
    goClassify(item) {
      switch (item.skipType) {
        case "0":
          // window.open(item.skipUrl);
          this.$router.push({
            path: "/external",
          });
          break;
        case "1":
          this.internalLink(item);
          break;
        case "2":
          break;
        default:
          break;
      }
    },
    internalLink(item) {
      // 详情为goosDetail;商品分类goodsClass
      // 推荐菜谱详情 menuDetails
      switch (item.skipUrl) {
        case "goodsClass":
           localStorage.setItem("categoryId", item.paramValue);
          this.$router.push({
            path: "/classify",
            query: { categoryId: item.paramValue, got: "true" }
          });
          break;
        case "goosDetail":
          this.$router.push({
            path: "/details",
            query: { goodsId: item.paramValue, got: "true" }
          });
          break;
        case "menuDetails":
          this.$router.push({
            path: "menuList/detailMenu",
            query: { cookbookId: item.paramValue, got: "true",remark:'my' }
          });
          break;
        default:
          break;
      }
    },
    // 下拉刷新
    onRefresh() {
      // 定时器在上线的时候去除
      setTimeout(() => {
        this.$toast("刷新成功");
        this.isLoading = false;
        this.getclassifyList();
      }, 500);
    },
    // 获取商品列表
    getclassifyList() {
      let params = {
        showType: "2"
      };
      this.$axios
        .post("operation/operationPosition/showAll", params)
        .then(res => {
          this.classifyList = res.data.data || [];
        })
        .catch(() => {});
    },
    //获取固定展示位
    getFixedList() {
      let params = {
        showType: "3"
      };
      this.$axios
        .post("operation/operationPosition/showAll", params)
        .then(res => {
          this.fixedUrl = res.data.data.length ? res.data.data[0] : {};
        })
        .catch(() => {});
    },
    //获取轮播图
    getSwipe() {
      let params = {
        showType: "1"
      };
      this.$axios
        .post("operation/operationPosition/showAll", params)
        .then(res => {
          this.swipeList = res.data.data || [];
        })
        .catch(() => {});
    },
    // 监听滚动事件
    handleScroll() {
      document.getElementById("below").style.display = "";
      let wid = document.getElementById("swipe").getBoundingClientRect().top;
      if (wid > 0) {
        this.$refs.below.style.height = wid + "px";
      } else {
        document.getElementById("below").style.display = "none";
      }
    },
    more() {
      this.$router.push("/category");
    }
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll, true); //监听页面滚动事件
  }
};
</script>

<style scoped>
.index {
  padding-top: 120px;
  transition: all 1s;
  background: rgba(242, 242, 242, 1);
  padding-bottom: 60px;
}
.content {
  height: 20%;
  overflow: hidden;
}
header {
  height: 120px;
  width: 100%;
  background: linear-gradient(
    180deg,
    rgba(172, 219, 86, 1) 0%,
    rgb(138, 194, 36) 100%
  );
  overflow: hidden;
  position: fixed;
  top: 0;
  z-index: 998;
}
h3 {
  text-align: center;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  line-height: 22px;
  margin-top: 25px;
}
.van-search {
  padding: 0;
  border-radius: 17px;
  margin: 20px 20px;
}
header >>> .van-field__left-icon {
  margin: 0 10px;
}
header >>> .van-icon-search {
  font-size: 20px;
}
.van-swipe-item {
  text-align: center;
}
.index-text {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 17px;
  margin-top: 5px;
}
.index >>> .van-image__img {
  border-radius: 50%;
}
.ty-index-loder {
  width: 90%;
  margin: 10px auto 0;
  background: rgba(255, 255, 255, 1);
  /* background-color: pink; */
  box-shadow: 0px 0px 4px 1px rgba(153, 153, 153, 0.1);
  border-radius: 10px;
  box-sizing: border-box;
}
.ty-index-h {
  height: 40px;
  padding: 10px 0 0 10px;
  box-sizing: border-box;
}
i {
  /* 字体对齐方式 */
  vertical-align: -10%;
  margin-right: 5px;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 17px;
}
.ty-index-h-span {
  margin-right: 5px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 17px;
}
.ty-index-show {
  width: 90%;
  height: 110px;
  margin: 30px auto 0 auto;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 1px 2px 0px rgba(153, 153, 153, 0.5);
  border-radius: 10px;
  box-sizing: border-box;
  overflow: hidden;
  -webkit-overflow-scrolling: touch;
}
.ty-index-show-l {
  margin-top: 20px;
  padding: 10px;
  height: 120px;
}
.ty-index-show-l-span {
  font-size: 16px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(116, 180, 43, 1);
  line-height: 22px;
}
.ty-index-show-l >>> .van-icon {
  margin: 0;
  vertical-align: -8%;
}
.ty-index-show-l >>> .van-button__text {
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  line-height: 18px;
}
/* 优惠卷 */
.coupons {
  display: flex;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
  -webkit-overflow-scrolling: touch;
  margin: 10px 20px 10px 0;
}
.promotion {
  width: 90%;
  margin: 20px auto 0;
  height: 40px;
  background: linear-gradient(
    90deg,
    rgba(93, 103, 239, 1) 0%,
    rgba(93, 103, 239, 0.4) 100%
  );
  border-radius: 8px 8px 0px 0px;
  padding: 10px;
  box-sizing: border-box;
}
.promotion-span {
  font-size: 16px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(255, 255, 255, 1);
}
.promotion-production {
  display: flex;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  width: 90%;
  height: 200px;
  margin: 0 auto;
  background-color: #fff;
}
.promotion-production-s {
  width: 92px;
  height: 172px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 1px 2px 0px rgba(153, 153, 153, 0.5);
  border-radius: 8px;
  padding: 10px;
  margin: 10px;
}
.promotion-production-s-img {
  width: 92px;
  height: 92px;
  border-radius: 2px;
}
.promotion-production-s-p {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  font-size: 12px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(102, 102, 102, 1);
  line-height: 17px;
}
.promotion-production-s-span-l,
.promotion-production-s-span-r {
  font-size: 12px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(245, 166, 35, 1);
  line-height: 17px;
}
.promotion-production-s-span-r {
  font-size: 6px;
}
.ty-index-show-l >>> .van-button--round,
.van-icon,
.van-icon-arrow {
  color: rgba(116, 180, 43, 1) !important;
}
.van-button__text {
  margin-left: 8px;
}
.below {
  height: 120px;
  background: linear-gradient(
    180deg,
    rgb(138, 194, 36) 30% rgba(116, 180, 43, 1) 100%
  );
  width: 100%;
  border-radius: 0 0 30px 30px;
  position: absolute;
}
.index >>> .van-grid-item__content {
  padding: 5px 8px;
}
.index >>> .van-swipe__track {
  /* width: 100% !important; */
  display: flex;
}
.ty_index_loder_footer {
  height: 5px;
  background-color: transparent !important;
}
.van-image {
  height: 49px;
  width: 49px;
}
/* 首屏加载 */
</style>